import { gql } from "apollo-boost";

const feedbacks = gql`
  query ($filter: UserFeedbackFilter) {
    feedbacks(filter: $filter) {
      total
      avgRating
      avgResponseTime
      items {
        id
        userId
        createDate
        title
        content
        resolved
        star
        type
        communities {
          id
          name
        }
        user {
          id
          name
          avatar
          lastName
        }
        responses {
          employeeId
          employeeName
          createDate
          content
        }
      }
    }
  }
`;

export const UserFeedbacks = gql`
  query userFeedbacks($id: String!) {
    userFeedbacks(id: $id) {
      id
      userId
      createDate
      title
      content
      resolved
      star
      type
      user {
        id
        name
        orgs {
          id
          name
        }
      }
      responses {
        employeeId
        employeeName
        createDate
        content
      }
    }
  }
`;

export const ResponseFeedback = gql`
  mutation responseFeedback($input: ResponseFeedbackInput!) {
    responseFeedback(input: $input) {
      userId
      createDate
      title
      content
      resolved
      star
      type
      user {
        id
        name
        orgs {
          id
          name
        }
      }
      responses {
        employeeId
        employeeName
        createDate
        content
      }
    }
  }
`;

export const feedbackGql = {
  feedbacks,
  UserFeedbacks,
  ResponseFeedback,
};
